// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SavedViewsList_savedViewsList__C4Zyi {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 16px;
  width: 100%;
}

.SavedViewsList_viewCard__\\+KZ1k {
  display: flex;
  align-items: center;
  padding: 16px;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  text-align: left;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  position: relative;
  overflow: hidden;
}
.SavedViewsList_viewCard__\\+KZ1k:hover {
  border-color: #3b82f6;
  box-shadow: 0 10px 15px -3px rgba(59, 130, 246, 0.1), 0 4px 6px -4px rgba(59, 130, 246, 0.1);
  transform: translateY(-2px);
}
.SavedViewsList_viewCard__\\+KZ1k:hover .SavedViewsList_deleteBtn__tp6yf {
  opacity: 1;
  transform: translateX(0);
}

.SavedViewsList_avatar__6Z7X8, .SavedViewsList_avatarPlaceholder__1DpWp {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  overflow: hidden;
  margin-right: 16px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f3f4f6;
  border: 1px solid #f3f4f6;
}
.SavedViewsList_avatar__6Z7X8 img, .SavedViewsList_avatarPlaceholder__1DpWp img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  padding: 4px;
  background: white;
}

.SavedViewsList_avatarPlaceholder__1DpWp {
  color: #9ca3af;
  font-size: 24px;
}

.SavedViewsList_viewInfo__ILnsj {
  flex: 1 1;
  min-width: 0;
}
.SavedViewsList_viewInfo__ILnsj .SavedViewsList_viewName__bgrK8 {
  font-size: 14px;
  font-weight: 600;
  color: #111827;
  margin-bottom: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.SavedViewsList_viewInfo__ILnsj .SavedViewsList_viewDate__GOjNt {
  font-size: 12px;
  color: #6b7280;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.SavedViewsList_actions__HKqtH {
  display: flex;
  align-items: center;
  margin-left: 8px;
}

.SavedViewsList_deleteBtn__tp6yf {
  opacity: 0;
  transform: translateX(10px);
  transition: all 0.2s ease;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  color: #9ca3af;
  cursor: pointer;
  background: transparent;
}
.SavedViewsList_deleteBtn__tp6yf:hover {
  color: #ef4444;
  background-color: #fef2f2;
}`, "",{"version":3,"sources":["webpack://./src/Explore/Components/SavedViewsList/SavedViewsList.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,4DAAA;EACA,SAAA;EACA,WAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,iDAAA;EACA,gBAAA;EACA,yCAAA;EACA,kBAAA;EACA,gBAAA;AACF;AACE;EACE,qBAAA;EACA,4FAAA;EACA,2BAAA;AACJ;AACI;EACE,UAAA;EACA,wBAAA;AACN;;AAIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,yBAAA;AADF;AAGE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;EACA,iBAAA;AADJ;;AAKA;EACE,cAAA;EACA,eAAA;AAFF;;AAKA;EACE,SAAA;EACA,YAAA;AAFF;AAIE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAFJ;AAKE;EACE,eAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAHJ;;AAOA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;AAJF;;AAOA;EACE,UAAA;EACA,2BAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,uBAAA;AAJF;AAME;EACE,cAAA;EACA,yBAAA;AAJJ","sourcesContent":[".savedViewsList {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n  gap: 16px;\n  width: 100%;\n}\n\n.viewCard {\n  display: flex;\n  align-items: center;\n  padding: 16px;\n  background: #ffffff;\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  cursor: pointer;\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n  text-align: left;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n  position: relative;\n  overflow: hidden;\n\n  &:hover {\n    border-color: #3b82f6;\n    box-shadow: 0 10px 15px -3px rgba(59, 130, 246, 0.1), 0 4px 6px -4px rgba(59, 130, 246, 0.1);\n    transform: translateY(-2px);\n\n    .deleteBtn {\n      opacity: 1;\n      transform: translateX(0);\n    }\n  }\n}\n\n.avatar, .avatarPlaceholder {\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  overflow: hidden;\n  margin-right: 16px;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #f3f4f6;\n  border: 1px solid #f3f4f6;\n\n  img {\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n    padding: 4px;\n    background: white;\n  }\n}\n\n.avatarPlaceholder {\n  color: #9ca3af;\n  font-size: 24px;\n}\n\n.viewInfo {\n  flex: 1;\n  min-width: 0;\n\n  .viewName {\n    font-size: 14px;\n    font-weight: 600;\n    color: #111827;\n    margin-bottom: 4px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  .viewDate {\n    font-size: 12px;\n    color: #6b7280;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n}\n\n.actions {\n  display: flex;\n  align-items: center;\n  margin-left: 8px;\n}\n\n.deleteBtn {\n  opacity: 0;\n  transform: translateX(10px);\n  transition: all 0.2s ease;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n  color: #9ca3af;\n  cursor: pointer;\n  background: transparent;\n\n  &:hover {\n    color: #ef4444;\n    background-color: #fef2f2;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"savedViewsList": `SavedViewsList_savedViewsList__C4Zyi`,
	"viewCard": `SavedViewsList_viewCard__+KZ1k`,
	"deleteBtn": `SavedViewsList_deleteBtn__tp6yf`,
	"avatar": `SavedViewsList_avatar__6Z7X8`,
	"avatarPlaceholder": `SavedViewsList_avatarPlaceholder__1DpWp`,
	"viewInfo": `SavedViewsList_viewInfo__ILnsj`,
	"viewName": `SavedViewsList_viewName__bgrK8`,
	"viewDate": `SavedViewsList_viewDate__GOjNt`,
	"actions": `SavedViewsList_actions__HKqtH`
};
export default ___CSS_LOADER_EXPORT___;
